exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".img-groepFoto{\n    width: 300px;  \n    height: auto !important;\n}\n.fixed-card {\n    width: 100px;\n    min-width: 120px;\n    border: black;\n    border: 1px solid rgba(0, 0, 0, .125);\n    border-radius: .25rem;\n}\n.showInModal{\n    padding-left: 5px;\n    padding-top: 0px;\n    padding-right: 5px;\n}\n\n.img-keepAspect {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n.modal-big {\n    max-width: 80% !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/ploeginfo/ploeginfo.component.css
// module id = 437
// module chunks = 0